import './App.css';
import { Button, Checkbox, Col, Form, Input, Row, Typography } from 'antd';


const { Title, Text } = Typography;

function Login() {
    return (
        <>
            <Row className={'page-row'} style={{
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}>
                <Col span={24}>
                    <Title level={3}>Login</Title>
                </Col>
            </Row>

            <Row className={'page-row'} style={{
                minHeight: 220,
                maxWidth: 1024,
                margin: '24px auto 0 auto'
            }}>
                <Col xs={0} md={7}>&nbsp;</Col>
                <Col xs={24} md={10}>

                    <Form
                        name="basic"
                        initialValues={{ remember: true }}
                        autoComplete="off"
                    >
                        <p>Site is under construction please come back latter.</p>
                        <br />
                        <Form.Item
                            label="Username"
                            name="username"
                            rules={[{ required: true, message: 'Please input your username!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: 'Please input your password!' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item name="remember" valuePropName="checked" label={null} style={{ float: 'right' }}>
                            <Checkbox>Remember me</Checkbox>
                        </Form.Item>

                        <Form.Item label={null} style={{ clear: 'right', float: 'right' }} name="remember">
                            <Button htmlType="submit">
                                Login
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
                <Col xs={0} md={7}>&nbsp;</Col>
            </Row>
        </>
    );
}

export default Login;
